import { FC, ReactNode } from 'react'

import { AuthProvider } from './auth'
import { ApplicationProvider } from './application'
import { CustomerProvider } from './customer'
import { RenewalProvider } from './renewal'
import { ErrorProvider } from './errors'


const AppProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <AuthProvider>
    <ErrorProvider>
      <ApplicationProvider>
        <CustomerProvider>
          <RenewalProvider>
            {children}
          </RenewalProvider>
        </CustomerProvider>
      </ApplicationProvider>
    </ErrorProvider>
  </AuthProvider>
)

export default AppProvider